import { createUsePuck, type Plugin } from '@puckeditor/core';
import { PUCK_TEMPLATE_ALPHA } from '~/editor/templates/alpha';

const usePuck = createUsePuck();

export const TemplatePlugin: Plugin = {
	name: 'photology-template',
	label: 'Templates',
	icon: <></>,
	render() {
		const dispatch = usePuck((s) => s.dispatch);

		const onClick = () => {
			dispatch({
				type: 'setData',
				data: {
					content: PUCK_TEMPLATE_ALPHA,
					root: { props: { title: 'Puck Example' } },
					zones: {},
				},
			});
		};

		return <button onClick={onClick}>set template</button>;
	},
};
